import { Routes, Route } from 'react-router-dom';

import AuthLayout from './layouts/AuthLayout';
import AppLayout from './layouts/AppLayout';

import LoginPage from '@/pages/auth/Login';
import { NotFoundPage } from '@/pages/NotFoundPage';
import HomePage from '@/pages/Home';
import loadable from '@/components/common/loadable';
import MaintenancePage from './pages/MaintenancePage';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import GlivePage from './pages/Glive';

export const SportsEventPage = loadable(() => import('@/pages/SportsEvent'));
export const FavouriteEventsPage = loadable(() => import('@/pages/FavouriteEventsPage'));
export const MarketDetailsPage = loadable(() => import('@/pages/MarketDetails'));
export const ParlayMarketDetailsPage = loadable(() => import('@/pages/parlay'));

export const CasinoPage = loadable(() => import('@/pages/CasinoPage/CasinoPage'));

export const LeaguePage = loadable(() => import('@/pages/LeaguePage'));
export const LeagueDetailsPage = loadable(() => import('@/pages/LeagueDetailsPage'));

export const ReferralPage = loadable(() => import('@/pages/Referral'));
export const BalanceOverviewPage = loadable(() => import('@/pages/BalanceOverview'));
export const ProfilePage = loadable(() => import('@/pages/Profile'));
export const ChangePasswordPage = loadable(() => import('@/pages/auth/ChangePassword'));
export const SettingPage = loadable(() => import('@/pages/Settings'));

export const AccountStatementPage = loadable(() => import('@/pages/Reports/AccountStatementPage'));
export const CurrentBetsPage = loadable(() => import('@/pages/Reports/CurrentBetsPage'));
export const BetsHistoryPage = loadable(() => import('@/pages/Reports/BetsHistoryPage'));
export const ProfitLossPage = loadable(() => import('@/pages/Reports/ProfitLossPage'));
export const ActivityLogPage = loadable(() => import('@/pages/Reports/ActivityLogPage'));
export const TurnoverHistoryPage = loadable(() => import('@/pages/TurnoverHistory'));
export const MyWalletPage = loadable(() => import('@/pages/MyWallet'));
export const BonusStatementPage = loadable(() => import('@/pages/BonusStatement'));
export const Promotions = loadable(() => import('@/pages/Promotions'));
export const PromotionDetails = loadable(() => import('@/pages/PromotionDetails'));

export function App() {
  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return (
      <Routes>
        <Route path="*" element={<MaintenancePage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
      </Route>

      <Route element={<AppLayout />}>
        <Route index path="/" element={<HomePage />} />
        <Route path="/glive" element={<GlivePage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/casino" element={<CasinoPage />} />
          <Route path="/newreferral" element={<ReferralPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/balance-overview" element={<BalanceOverviewPage />} />
          <Route path="/current-bets" element={<CurrentBetsPage />} />
          <Route path="/account-statement" element={<AccountStatementPage />} />
          <Route path="/bets-history" element={<BetsHistoryPage />} />
          <Route path="/profit-loss" element={<ProfitLossPage />} />
          <Route path="/activity-log" element={<ActivityLogPage />} />
          <Route path="/turnover-history" element={<TurnoverHistoryPage />} />
          <Route path="/wallet" element={<MyWalletPage />} />
          <Route path="/bonus-statement" element={<BonusStatementPage />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/promotion/:id" element={<PromotionDetails />} />
          <Route path="/setting" element={<SettingPage />} />
          <Route path="/favourite-events" element={<FavouriteEventsPage />} />
          <Route path="/fullmarket/:sportName/:eventId" element={<ParlayMarketDetailsPage />} />
        </Route>

        <Route path="/leagues" element={<LeaguePage />} />
        <Route path="/leagues/:sport/:competitionId" element={<LeagueDetailsPage />} />
        <Route path="/sports/:sport/:schedule" element={<SportsEventPage />} />
        <Route path="/marketdetails/:sportName/:eventId" element={<MarketDetailsPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
